import * as types from "./types";
import {
    getDocumentList,
    shareFileDownloadAxios,
    deleteDocument,
    uploadMultipleDocuments,
    uploadDocument,
    downloadDocument
} from "./services";

export async function getDocumentListAction({ commit }, {id, type = null, typeId = null}) {
    commit(types.LOADING_DOCUMENT, true);
    try {
        const { data } = await getDocumentList(id, type, typeId);
        commit(types.GET_DOCUMENT_LIST, data.data);
    }
    catch (e) {
        throw e;
    }
    finally {

        commit(types.LOADING_DOCUMENT, false);
    }
}

export async function removeDocumentAction({ commit }, payload) {
    commit(types.LOADING_DOCUMENT, true);
    try {
        await deleteDocument(payload);
        commit(types.REMOVE_DOCUMENT, payload);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_DOCUMENT, false);
    }
}

export async function downloadDocumentAction({ commit }, payload) {
    commit(types.LOADING_DOCUMENT, true);
    try {
        await downloadDocument(payload);
        commit(types.DOWNLOAD_DOCUMENT, payload);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_DOCUMENT, false);
    }
}


export async function uploadDocumentAction({ commit }, {payload, referenceId = null, type = null, typeId = null}) {
    commit(types.LOADING_DOCUMENT, true);
    try {
        await uploadDocument(payload, referenceId, type, typeId);
        commit(types.ADD_DOCUMENT, payload);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_DOCUMENT, false);
    }
}


export async function uploadMultipleDocumentAction({ commit }, {payload, referenceId = null, type = null, typeId = null}) {
    commit(types.LOADING_DOCUMENT, true);
    try {
        await uploadMultipleDocuments(payload, referenceId, type, typeId);
        commit(types.ADD_MULTI_DOCUMENT, payload);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_DOCUMENT, false);
    }
}

export async function fileSharingAction({ commit }, file) {
    commit(types.LOADING_DOCUMENT, true);
    try {
        const { data }= await shareFileDownloadAxios(file);
        commit(types.FILE_SHARING, data.result);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_DOCUMENT, false);
    }

    
}